module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-container', {
    staticClass: "container"
  }, [_c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e895512"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/home.vue
// module id = 968
// module chunks = 30